const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

export const formatFilterDate = (date: Date): string =>
  date.toLocaleDateString("en-GB", DATE_FORMAT_OPTIONS);

export const areSelectionsEqual = (a: string[], b: string[]): boolean => {
  if (a.length !== b.length) return false;
  const setB = new Set(b);
  return a.every((name) => setB.has(name));
};

const toDayNumber = (date: Date): number =>
  date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();

/**
 * Day-granularity containment. The backend's row filter compares `.date()` on
 * both bounds, so a sprint ending at 23:59 on the end day is inside the range;
 * comparing the raw timestamps here would disagree with it.
 */
export const isDateWithinRange = (
  date: Date,
  start: Date,
  end: Date,
): boolean => {
  const day = toDayNumber(date);
  return day >= toDayNumber(start) && day <= toDayNumber(end);
};
